import React from "react";
import { useQuery } from "@apollo/client/react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from "@mui/material/CircularProgress";

import AssetItemImage from "../../capture/aseet-list/AssetItemImage";

import useQueryParams from "src/hooks/useQueryParams";
import { ASSETS_BY_IDS_WITH_QUANTITY_QUERY } from "src/constants/graphql/queries";

export default function ItemsAlreadyMoved() {
  const params = useQueryParams();
  const movedAssetIdsParam = params.get("movedAssetIds");
  const movedAssetIds = movedAssetIdsParam ? movedAssetIdsParam.split(",") : [];
  const { data, loading } = useQuery(ASSETS_BY_IDS_WITH_QUANTITY_QUERY, {
    variables: { assetIds: movedAssetIds },
    skip: movedAssetIds.length === 0,
  });

  const movedAssets = data?.assetsCollection?.collection || [];

  if (movedAssetIds.length === 0) {
    return null;
  }

  return (
    <Box mt={3}>
      <Box display="flex" alignItems="center" justifyContent="center" gap={1} mb={1}>
        <Typography variant="body2" color="text.secondary" fontWeight={500}>
          Items Moved So Far ({movedAssets.length})
        </Typography>
      </Box>
      {loading ? (
        <Box display="flex" justifyContent="center" py={2}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <List
          sx={{
            bgcolor: "success.50",
            borderRadius: 1,
            border: "1px solid",
            borderColor: "divider",
            py: 0,
          }}
        >
          {movedAssets.map((asset, index) => (
            <React.Fragment key={asset.id}>
              {index > 0 && <Divider component="li" />}
              <ListItem sx={{ py: 1, px: 2 }}>
                <ListItemAvatar sx={{ minWidth: 56 }}>
                  <AssetItemImage
                    images={asset.images}
                    width={44}
                    minWidth={44}
                    height={44}
                    minHeight={44}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="body2" fontWeight={500} color="text.primary">
                      {asset.itemId}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {asset.description || "No description"}
                    </Typography>
                  }
                />
              </ListItem>
            </React.Fragment>
          ))}
        </List>
      )}
    </Box>
  );
}
